



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AccountState from "@/models/Accounts/Shared/AccountState";

@Component({ name: 'AccountState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: AccountState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case AccountState.Active:
                color = "success--text";
                break;
            case AccountState.ReadOnly:
                color = "warning--text";
                break;
            case AccountState.Closed:
                color = "error--text";
                break;
        }
        return color;
    }

}
